export type DisplayAttribute = {
  type?: string;
  category?: string | null;
  name: string;
  value: string[];
  attachments?: unknown[] | null;
};

export function isDisplayableAttribute(attribute: DisplayAttribute): boolean {
  if (attribute.type === 'attachment') {
    return Boolean(attribute.attachments && attribute.attachments.length > 0);
  }

  if (!attribute.value || !Array.isArray(attribute.value)) {
    return false;
  }

  return attribute.value[0] !== '';
}

export function hasDisplayableAttributes(
  attributes: DisplayAttribute[] | null | undefined
): boolean {
  if (!attributes || attributes.length === 0) return false;

  return attributes.some(isDisplayableAttribute);
}

export function applyAttributeCategoryFromName<T extends DisplayAttribute>(
  attribute: T
): T {
  if (!attribute.category && attribute.name.includes(' \\ ')) {
    const parts = attribute.name.split(' \\ ');
    const category = parts[0].trim();
    const name = parts.slice(1).join(' \\ ').trim();
    return { ...attribute, category, name };
  }

  return attribute;
}
